import {
  AllowEmptyDlfMatcher,
  AllowEmptyDlfMatcherProperties,
} from "./AllowEmptyDlfMatcher";
import { DlfMatcherTypes } from "../../types/rules/DlfMatcherTypes";

type RegexFieldMatcherData = {
  regex: string;
} & AllowEmptyDlfMatcherProperties;

class RegexFieldMatcher
  extends AllowEmptyDlfMatcher
  implements RegexFieldMatcherData
{
  allowEmpty: boolean;
  discriminator: DlfMatcherTypes = "F_REGEX";
  /* Regex Field Matcher properties */
  regex: string;
  /* Dlf Matcher property */
  fieldName: string;
  /* Matcher properties */
  threshold: number;
  position: number;
  reusable: boolean;
  ocrConfidenceThreshold: number;

  constructor(data: RegexFieldMatcherData) {
    super();
    this.fieldName = data.fieldName;
    this.regex = data.regex ?? "";
    this.position = data.position;
    this.reusable = data.reusable ?? true;
    this.allowEmpty = data.allowEmpty ?? false;
    this.threshold = data.threshold;
    this.ocrConfidenceThreshold = data.ocrConfidenceThreshold;
  }
  isConfigured(): boolean {
    return this.regex !== "";
  }
  clear(): void {
    this.regex = "";
  }

  toMatcherData(): RegexFieldMatcherData {
    return {
      discriminator: this.discriminator,
      allowEmpty: this.allowEmpty,
      fieldName: this.fieldName,
      position: this.position,
      regex: this.regex,
      reusable: this.reusable,
      threshold: this.threshold,
      ocrConfidenceThreshold: this.ocrConfidenceThreshold,
    };
  }

  getDiscriminator(): DlfMatcherTypes {
    return this.discriminator;
  }
  getReusable(): boolean {
    return this.reusable;
  }
  setReusable(value: boolean): void {
    this.reusable = value;
  }
  toggleAllowEmpty(): boolean {
    this.setAllowEmpty(!this.getAllowEmpty());
    return this.getAllowEmpty();
  }
  setAllowEmpty(value: boolean): void {
    this.allowEmpty = value;
  }
  getAllowEmpty(): boolean {
    return this.allowEmpty;
  }

  getMatcherId(): string {
    return `${this.discriminator}-${this.threshold}-${this.ocrConfidenceThreshold}-${this.regex}`;
  }

  static createTest(
    rest: Partial<RegexFieldMatcherData> = {},
  ): RegexFieldMatcher {
    const data: RegexFieldMatcherData = {
      regex: "",
      fieldName: "",
      allowEmpty: false,
      position: 0,
      reusable: true,
      discriminator: "F_REGEX",
      threshold: 0,
      ocrConfidenceThreshold: -1,
    };

    return new RegexFieldMatcher({
      ...data,
      ...rest,
    });
  }
}

export { RegexFieldMatcher, RegexFieldMatcherData };
